import * as R from 'ramda'
import { createSelector } from 'reselect'

import { dbSelector } from './base'
import * as boardSelectors from 'src/store/selectors/board'

const boardSelector = createSelector(
  dbSelector,
  boardSelectors.boardIdSelector,
  (db, boardId) => {
    return db[boardId]
  }
)

export const pinnedPostSelector = createSelector(
  boardSelector,
  R.prop('@board/pinned-to-top')
)

// @TODO: Mjlikre delete this when pointlog is in graphql

export const boardLogSelector = createSelector(boardSelector, R.prop('log'))

export const currentPeriodPointAdjustmentSelector = createSelector(
  boardLogSelector,
  R.pipe(
    R.findLast(
      R.pathSatisfies(R.lte(R.__, Date.now()), [
        0,
        ':grading-period/start-date'
      ])
    ),
    R.pathOr(0, [0, 'pointAdjustment'])
  )
)
